import { NgModule } from "@angular/core";
import { CoreModule } from "./core/core.module";
import { SharedModule } from "./shared/shared.module";
import { BrowserModule, HAMMER_GESTURE_CONFIG } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { PageLoaderComponent } from "./layout/page-loader/page-loader.component";
import { ErrorInterceptor } from "./core/interceptor/error.interceptor";
import { LocationStrategy, HashLocationStrategy } from "@angular/common";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CookieService } from 'ngx-cookie-service';
import {
    HttpClientModule,
    HTTP_INTERCEPTORS,
    HttpClient,
    HttpClientXsrfModule, HttpXsrfTokenExtractor
} from "@angular/common/http";
import { SocialLoginModule, SocialAuthServiceConfig } from '@abacritt/angularx-social-login';
import { GoogleLoginProvider, FacebookLoginProvider} from '@abacritt/angularx-social-login';
import { LoadingBarRouterModule } from "@ngx-loading-bar/router";
import { NgScrollbarModule } from "ngx-scrollbar";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { NgbDropdownModule, NgbModule, NgbPaginationModule, NgbPopoverModule, NgbRatingModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { TestComponent } from './pages/test/test.component';
import { MatTabsModule } from "@angular/material/tabs";
import { ComponentsModule } from "./shared/components/components.module";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { OnboardingCompanyComponent } from './pages/onboarding-company/onboarding-company.component'; // <-- import the module
import { MatStepperModule } from "@angular/material/stepper";
import { MatSelectModule } from "@angular/material/select";
import { NgxDropzoneModule } from 'ngx-dropzone';
import { StylePaginatorDirective } from './directives/style-paginator/style-paginator.directive';
import { UserManagementComponent } from './pages/user-management/user-management.component';
import { HeaderInterceptor } from "./core/interceptor/header.interceptor";
import { DeleteItemComponent } from './pages/delete-item/delete-item.component';
import { HireRecruiterComponent } from './pages/dialog-modal/hire-recruiter/hire-recruiter.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { EditUserComponent } from './pages/dialog-modal/edit-user/edit-user.component';
import { CoursesComponent } from './pages/courses/courses/courses.component';
import { AddUserComponent } from './pages/dialog-modal/add-user/add-user.component';
import { TemplateCourseComponent } from './pages/courses/template-course/template-course.component';
import { AddCourseComponent } from './pages/courses/add-course/add-course.component';
import { EllipsisPipe } from "./pipes/ellipsis/ellipsis.pipe";
// import { SelectObjectComponent } from './pages/courses/select-object/select-object.component';
import { QuillModule } from 'ngx-quill';

import { MatProgressBarModule } from "@angular/material/progress-bar";
import { CourseDashboardComponent } from './pages/courses/course-dashboard/course-dashboard.component';
import { ViewCourseComponent } from './pages/courses/view-course/view-course.component';
import { CompanyCourseDashboardComponent } from './pages/courses/company-course-dashboard/company-course-dashboard.component';
import { ConfirmationModalComponent } from './pages/dialog-modal/confirmation-modal/confirmation-modal.component';
import { AssignCourseComponent } from './pages/courses/assign-course/assign-course.component';
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule } from "@angular-material-components/datetime-picker";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { MatMomentDateModule, MomentDateAdapter, MomentDateModule } from '@angular/material-moment-adapter';
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, "assets/i18n/", ".json");
}
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { ImportantNoticeComponent } from './pages/important-notice/important-notice.component';
import { AddImportantNoticeComponent } from './pages/add-important-notice/add-important-notice.component';
import { ForumManagementComponent } from './pages/forum/forum-management/forum-management.component';
import { AddForumComponent } from './pages/forum/add-forum/add-forum.component';
import { StaffSurveyDashboardComponent } from './pages/staff-survey/staff-survey-dashboard/staff-survey-dashboard.component';
import { StaffSurveyComponent } from './pages/staff-survey/staff-survey/staff-survey.component';
import { ViewExamsheetComponent } from './pages/courses/view-examsheet/view-examsheet.component';
import { MoreCourseInfoComponent } from './pages/courses/more-course-info/more-course-info.component';
import { AppImgFallbackDirective } from './directives/appImgFallback/app-img-fallback.directive';
import { MatSliderModule } from "@angular/material/slider";
import { DocumentsComponent } from './pages/documents/documents.component';
import { DocumentDashboardComponent } from './pages/documents/document-dashboard/document-dashboard.component';
import { AssignStaffSurveyComponent } from './pages/staff-survey/assign-staff-survey/assign-staff-survey.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { MY_FORMATS } from "./model/date_format";
import { MatCardModule } from "@angular/material/card";
import { StripePaymentComponent } from './pages/stripe-payment/stripe-payment.component';
import { ExamResultComponent } from "./pages/individual/exam-result/exam-result.component";
import { NgxStripeModule } from 'ngx-stripe';
import { GlobalService } from "./services/global/global.service";
import { NgxPermissionsModule } from 'ngx-permissions';
import { ImportCsvComponent } from './pages/dialog-modal/import-csv/import-csv.component';
import { OWL_DATE_TIME_FORMATS } from "@danielmoncada/angular-datetime-picker";
import { AlertComponent } from './pages/alert/alert.component';
import { FeatureComponent } from './pages/feature/feature.component';
import { DepartmentComponent } from './pages/department/department/department.component';
import { AddDepartmentComponent } from './pages/department/add-department/add-department.component';
import { ViewDepartmentComponent } from './pages/department/view-department/view-department.component';
import { AddStoreComponent } from './pages/store/add-store/add-store.component';
import { CertificateManagementComponent } from "./pages/certificate/certificate-management/certificate-management.component";
import { AssignCourseEmployeeWiseComponent } from './pages/courses/assign-course-employee-wise/assign-course-employee-wise.component';
import { CustomTostComponent } from './custom-tost/custom-tost.component';
import { ViewImportantNoticeComponent } from './pages/important-notice/view-important-notice/view-important-notice/view-important-notice.component';
import { RecruitmentPortalComponent } from './pages/recruitment-portal/recruitment-portal.component';
import { FixedScrollDirective } from "./directives/fixed-scroll/fixed-scroll.directive";
import { CourseBuilderComponent } from './pages/courses/course-builder/course-builder.component';
import { ViewStoreCommentComponent } from './pages/store/view-store-comment/view-store-comment.component';
import { ResizeDirective } from './directives/resize/resize.directive';
import { ViewCompanyComponent } from './pages/view-company/view-company.component';
import { NotificationComponent } from './pages/notification/notification.component';
import { MY_OWL_FORMATS } from "./model/owl_date";
import { AddCategoryComponent } from './pages/company-settings/add-category/add-category.component';
import { AgmCoreModule } from "@agm/core";
import { AddLocationComponent } from "./pages/recruitment/add-location/add-location.component";
import { JobRequestComponent } from './page/recruitment/job-request/job-request.component';
import { ChatComponent } from './pages/chat/chat.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AddSingleUserComponent } from './pages/dialog-modal/add-single-user/add-single-user.component';
import { ViewCompanyEmpComponent } from './pages/view-company-emp/view-company-emp.component';
import { CourseDashboardCComponent } from './pages/courses/course-dashboard-c/course-dashboard-c.component';
import { InfoModalComponent } from './pages/dialog-modal/info-modal/info-modal.component';
import { CourseDetailsCComponent } from './pages/courses/course-details-c/course-details-c.component';
import { MatMenuModule } from '@angular/material/menu';
import { CreateDressCodeComponent } from "./pages/company-settings/create-dress-code/create-dress-code.component";

@NgModule({
    declarations: [
        AppImgFallbackDirective,
        AppComponent,
        PageLoaderComponent,
        TestComponent,
        OnboardingCompanyComponent,
        StylePaginatorDirective,
        UserManagementComponent,
        DeleteItemComponent,
        HireRecruiterComponent,
        EditUserComponent,
        CoursesComponent,
        AddUserComponent,
        TemplateCourseComponent,
        AddCourseComponent,
        EllipsisPipe,
        CourseDashboardComponent,
        ViewCourseComponent,
        CompanyCourseDashboardComponent,
        ConfirmationModalComponent,
        AssignCourseComponent,
        ImportantNoticeComponent,
        AddImportantNoticeComponent,
        CertificateManagementComponent,
        ForumManagementComponent,
        AddForumComponent,
        StaffSurveyDashboardComponent,
        StaffSurveyComponent,
        ViewExamsheetComponent,
        MoreCourseInfoComponent,
        DocumentsComponent,
        DocumentDashboardComponent,
        AssignStaffSurveyComponent,
        StripePaymentComponent,
        ExamResultComponent,
        ImportCsvComponent,
        AlertComponent,
        FeatureComponent,
        DepartmentComponent,
        AddDepartmentComponent,
        ViewDepartmentComponent,
        AddStoreComponent,
        AssignCourseEmployeeWiseComponent,
        CustomTostComponent,
        ViewImportantNoticeComponent,
        RecruitmentPortalComponent,
        FixedScrollDirective,
        CourseBuilderComponent,
        ViewStoreCommentComponent,
        ResizeDirective,
        ViewCompanyComponent,
        NotificationComponent,
        AddCategoryComponent,
        AddLocationComponent,
        JobRequestComponent,
        ChatComponent,
        AddSingleUserComponent,
        ViewCompanyEmpComponent,
        CourseDashboardCComponent,
        InfoModalComponent,
        CourseDetailsCComponent,
        CreateDressCodeComponent
                   
    ],
    providers: [
        {
            provide: 'SocialAuthServiceConfig',
            useValue: {
                autoLogin: false,
                providers: [
                    {
                        id: GoogleLoginProvider.PROVIDER_ID,
                        provider: new GoogleLoginProvider('843405036032-caslnbcqu4ut9hht531v0444qedrisqd.apps.googleusercontent.com',
    
                            {
                                oneTapEnabled: false, // <===== default is true
                            })
                    },
                    {
                        id: FacebookLoginProvider.PROVIDER_ID,
                        // provider: new FacebookLoginProvider('322103562489596')
                        provider: new FacebookLoginProvider('1198603260987487')
                    }
                ],
                onError: (err) => {
                    console.error(err,'ddd');
                }
            } as SocialAuthServiceConfig,
        },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        // { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },       
        { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
 
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        { provide: OWL_DATE_TIME_FORMATS, useValue: MY_OWL_FORMATS },
        {
            provide: MatDialogRef,
            useValue: {}
        },
        CookieService,
        DatePipe
    ],
    bootstrap: [AppComponent],
    imports: [
        MatMenuModule,
        MatTabsModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        HttpClientModule,
        LoadingBarRouterModule,
        ReactiveFormsModule,
        NgScrollbarModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
        // core & shared
        CoreModule,
        SharedModule,
        SocialLoginModule,
        MatSnackBarModule,
        ComponentsModule,
        MatStepperModule,
        MatSelectModule,
        NgxDropzoneModule,
        HttpClientModule,
        NgMultiSelectDropDownModule.forRoot(),
        MatProgressBarModule,
        NgbTimepickerModule,
        MatMomentDateModule,
        NgxMaterialTimepickerModule,
        MatDialogModule,
        QuillModule.forRoot({
            modules: {
                syntax: true,
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                    ['blockquote', 'code-block'],
                    // custom button values
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
                    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                    // [{ 'font': [] }],
                    [{ 'align': '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                    ['clean'],                                         // remove formatting button            
                    ['image',]               // remove formatting button
                ]
            },
            theme: 'snow'
        }),
        NgxMatDatetimePickerModule,
        MatDatepickerModule,
        MatInputModule,
        NgxMatTimepickerModule,
        NgxMatNativeDateModule,
        MomentDateModule,
        NgbPopoverModule,
        NgbRatingModule,
        MatSliderModule,
        NgbPaginationModule,
        // NgxAudioPlayerModule,
        MatCardModule,
        NgxStripeModule.forRoot(GlobalService.stripePublishKey),
        NgxPermissionsModule.forRoot(),
        HttpClientXsrfModule.withOptions({
            cookieName: 'XSRF-TOKEN', // The name of the cookie that will contain the XSRF token
            headerName: 'X-XSRF-TOKEN', // The name of the header that will contain the XSRF token
        }),
     
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyAv1Rb1OD_nn1BQZPgdJHToI6DZTHa06gc',
            libraries: ['places']
        }),
        
    ],
    entryComponents:[
        // AddLocationComponent,
    ]
})
export class AppModule { }